<template>
  <div class="actions-container" :class="categoryName">
    <div class="action-container">
      <action v-for="(action, index) of actions" :key="index" v-bind="action"/>
    </div>
  </div>
</template>

<script>

import Action from './Action.vue';

export default {
  name: 'Actions',
  components: {
    Action,
  },
  props: {
    actions: Array,
    categoryName: String,
  },
};
</script>

<style lang="scss" scoped>
  @import '~base-ui/src/scss/riseup-colors';

  .actions-container {
    &.variable {
      background-color: $riseup_mustard;
    }
    &.recurringEconomy {
      background-color: $riseup_light_blue;
    }
    &.trackingCategory {
      background-color: $riseup_light_blue;;
    }
    &.excludedExpense {
      background-color: $riseup_black;
    }
    &.excludedIncome {
      background-color: $riseup_black;
    }
    &.fixedExpense {
      background-color: $riseup_coral;
    }
    &.fixedIncome {
      background-color: $riseup_green;
    }
    &.variableIncome {
      background-color: $riseup_green;
    }

    padding: 0 20px;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;

    .action-container {
      border-bottom: 1px solid $riseup_white;
      &:last-of-type {
        border-bottom: none;
      }
    }
  }
</style>
